import {
  usePopoverDismiss
} from "./HRXPFA6C.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";

// src/hovercard/hovercard-dismiss.ts
var useHovercardDismiss = createHook(
  (props) => {
    props = usePopoverDismiss(props);
    return props;
  }
);
var HovercardDismiss = createComponent(
  (props) => {
    const htmlProps = useHovercardDismiss(props);
    return createElement("button", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  HovercardDismiss.displayName = "HovercardDismiss";
}

export {
  useHovercardDismiss,
  HovercardDismiss
};
